module.exports = __webpack_public_path__ + "static/img/par5.56ee251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par5.png
// module id = ULW/
// module chunks = 0